/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Table, Typography } from '@quickbit/qb-design-system';
import { OnboardingHistory } from 'tabs/AffiliateUsers/types';

const getRiskScore = (code: string, onboarding: any) => {
  const question = onboarding.questions[code];
  const answers = onboarding.answers[code];
  const combinator = question.combinator;
  if (combinator === 'SUM') {
    return answers.reduce((acc: number, answer: string) => {
      const riskScore = question.choices.filter(
        (choice: any) => choice.uuid === answer
      )[0].risk;
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return acc + riskScore;
    }, 0);
  }
  return answers.reduce((acc: number, answer: string) => {
    const riskScore = question.choices.filter(
      (choice: any) => choice.uuid === answer
    )[0].risk;
    return riskScore > acc ? riskScore : acc;
  }, 0);
};

interface Props {
  onboarding: Omit<OnboardingHistory, 'createdAt'>;
}

export const OnboardingTable = ({ onboarding }: Props) => {
  return (
    <Table
      headers={[
        { label: 'Question', cellKey: 'question', sort: false },
        { label: 'Answer', cellKey: 'answer', sort: false },
        { label: 'Risk score', cellKey: 'riskScore', sort: false },
      ]}
      rows={Object.entries(onboarding.questions).map(([code, question]) => ({
        value: {
          question: (
            <>
              <Typography variant="bodyBold">{question.header}</Typography>
              <Typography variant="bodySmallestMedium">({code})</Typography>
            </>
          ),
          answer: (
            <Typography>
              {onboarding.answers[code]
                .map(
                  (choiceId: any) =>
                    question.choices.filter(
                      (choice: any) => choice.uuid === choiceId
                    )[0].text
                )
                .join(', ')}
            </Typography>
          ),
          riskScore: <Typography>{getRiskScore(code, onboarding)}</Typography>,
        },
      }))}
    />
  );
};
